CANDYRACK_DOCUMENT_LISTENER = true;

CANDYRACK_CUSTOM_BUTTON_SELECTORS = [".gf_add-to-cart"];

CANDYRACK_VARIANT_SELECTOR_FUNCTION = (btn) => {
     const variant = document.querySelector("input[name='id']")
    if (variant) {
     return Number(varinat.value)
    }
}